import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ZoomerImg from "../../assets/image/zoomer-logo.png";
import ArtVenue from "../../assets/image/art-venue-logo.png";
import AuthorImg from "../../assets/image/author-image.png";

function Learner() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <div className="learner-background mt-5">
      <div className="text-center">
        <div className="learner-header">
          <h6 className="mt-5">VOICES OF SUCCESS</h6>
          <h3>Here What Our Learners Are Saying</h3>
        </div>
      </div>
      <Carousel responsive={responsive}>
        <div className="col-md-12 ">
          <div className="card text-align-center custom-card">
            <div className="card-body">
              <img src={ZoomerImg} alt="Zoomer" className="card-logo" />
              <p className="card-text">
                The 30-day challenge completely changed how I approach problem solving. 
                Each day pushed me just enough out of my comfort zone without being overwhelming. 
                The structured progression from basics to advanced topics is brilliant.
              </p>
              <div className="card-footer">
                <img src={AuthorImg} alt="" />
                <p className="author-name">Rahul Sharma</p>
                <p className="author-role">Software Engineer, Zoomer</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 ">
          <div className="card custom-card text-center">
            <div className="card-body">
              <img src={ArtVenue} alt="Art Venue" className="card-logo" />
              <p className="card-text">
                I was struggling with DSA concepts for months before joining this program. 
                The daily practice and mentor feedback helped me finally crack interviews 
                at top product-based companies. Highly recommended for freshers.
              </p>
              <div className="card-footer">
                <img src={AuthorImg} alt="" />
                <p className="author-name">Priya Patel</p>
                <p className="author-role">Frontend Developer, Art Venue</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 ">
          <div className="card custom-card text-center">
            <div className="card-body">
              <img src={ZoomerImg} alt="Zoomer" className="card-logo" />
              <p className="card-text">
                What sets this apart is the quality of explanations and the community 
                discussions around each problem. Even after 20 days my fundamentals 
                had become rock solid. The recursion and DP sections were especially well-structured.
              </p>
              <div className="card-footer">
                <img src={AuthorImg} alt="" />
                <p className="author-name">Arun Kumar</p>
                <p className="author-role">Backend Developer, Zoomer</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 ">
          <div className="card custom-card text-center">
            <div className="card-body">
              <img src={ArtVenue} alt="Art Venue" className="card-logo" />
              <p className="card-text">
                The hands-on approach made all the difference. Instead of just watching 
                tutorials, I was actually coding every single day. The instant feedback 
                on my solutions helped me identify and fix bad patterns early on.
              </p>
              <div className="card-footer">
                <img src={AuthorImg} alt="" />
                <p className="author-name">Sneha Reddy</p>
                <p className="author-role">Full Stack Developer</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 ">
          <div className="card custom-card text-center">
            <div className="card-body">
              <img src={ZoomerImg} alt="Zoomer" className="card-logo" />
              <p className="card-text">
                I had two years of experience but never felt confident about my DSA skills. 
                This 30-day program filled all the gaps. The sliding window and graph 
                algorithm days were my favorites. Worth every minute spent.
              </p>
              <div className="card-footer">
                <img src={AuthorImg} alt="" />
                <p className="author-name">Vikram Singh</p>
                <p className="author-role">Senior Developer, Zoomer</p>
              </div>
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
}

export default Learner;
